module.exports = __webpack_public_path__ + "d664201f/img/saly-icon.39e12342.jpg";